export const PAYMENT_METHOD = {
  Cash: 1,
  Pix: 2,
  CreditCard: 3,
  DebitCard: 4,
} as const;

export const PAYMENT_METHOD_LABELS: Record<number, string> = {
  [PAYMENT_METHOD.Cash]: "Dinheiro",
  [PAYMENT_METHOD.Pix]: "Pix",
  [PAYMENT_METHOD.CreditCard]: "Cartão de crédito",
  [PAYMENT_METHOD.DebitCard]: "Cartão de débito",
};

export const CASH_SESSION_STATUS = {
  Open: 1,
  Closed: 2,
} as const;

export const CASH_SESSION_STATUS_LABELS: Record<number, string> = {
  [CASH_SESSION_STATUS.Open]: "Aberto",
  [CASH_SESSION_STATUS.Closed]: "Fechado",
};

export const CASH_TRANSACTION_TYPE = {
  OpeningBalance: 1,
  SaleEntry: 2,
  Supply: 3,
  Bleed: 4,
  Refund: 5,
} as const;

export const CASH_TRANSACTION_TYPE_LABELS: Record<number, string> = {
  [CASH_TRANSACTION_TYPE.OpeningBalance]: "Abertura",
  [CASH_TRANSACTION_TYPE.SaleEntry]: "Venda",
  [CASH_TRANSACTION_TYPE.Supply]: "Suprimento",
  [CASH_TRANSACTION_TYPE.Bleed]: "Sangria",
  [CASH_TRANSACTION_TYPE.Refund]: "Estorno",
};

export const SALE_STATUS = {
  Open: 1,
  PendingPayment: 2,
  Completed: 3,
  Canceled: 4,
} as const;

export const SALE_STATUS_LABELS: Record<number, string> = {
  [SALE_STATUS.Open]: "Aberta",
  [SALE_STATUS.PendingPayment]: "Pagamento pendente",
  [SALE_STATUS.Completed]: "Concluída",
  [SALE_STATUS.Canceled]: "Cancelada",
};

export const SALE_TYPE = {
  QuickSale: 1,
  Tab: 2,
} as const;

export const SALE_TYPE_LABELS: Record<number, string> = {
  [SALE_TYPE.QuickSale]: "Venda rápida",
  [SALE_TYPE.Tab]: "Comanda",
};

export const SPORT_TYPE = {
  BeachTennis: 1,
  Footvolley: 2,
  Volleyball: 3,
  Tennis: 4,
  Soccer: 5,
  Padel: 6,
} as const;

export const SPORT_TYPE_LABELS: Record<number, string> = {
  [SPORT_TYPE.BeachTennis]: "Beach tennis",
  [SPORT_TYPE.Footvolley]: "Futevôlei",
  [SPORT_TYPE.Volleyball]: "Vôlei",
  [SPORT_TYPE.Tennis]: "Tênis",
  [SPORT_TYPE.Soccer]: "Futebol",
  [SPORT_TYPE.Padel]: "Padel",
};

export const BOOKING_STATUS = {
  Confirmed: 1,
  PendingPayment: 2,
  Completed: 3,
  Canceled: 4,
  NoShow: 5,
} as const;

export const BOOKING_STATUS_LABELS: Record<number, string> = {
  [BOOKING_STATUS.Confirmed]: "Confirmada",
  [BOOKING_STATUS.PendingPayment]: "Pagamento pendente",
  [BOOKING_STATUS.Completed]: "Concluída",
  [BOOKING_STATUS.Canceled]: "Cancelada",
  [BOOKING_STATUS.NoShow]: "Falta (no-show)",
};

export const PLAN_BILLING_PERIOD = {
  Weekly: 1,
  Monthly: 2,
} as const;

export const PLAN_BILLING_PERIOD_LABELS: Record<number, string> = {
  [PLAN_BILLING_PERIOD.Weekly]: "Semanal",
  [PLAN_BILLING_PERIOD.Monthly]: "Mensal",
};

export const EXPENSE_CATEGORY = {
  Rent: 1,
  Utilities: 2,
  Payroll: 3,
  Maintenance: 4,
  Services: 5,
  Taxes: 6,
  Supplies: 7,
  Marketing: 8,
  Other: 9,
} as const;

export const EXPENSE_CATEGORY_LABELS: Record<number, string> = {
  [EXPENSE_CATEGORY.Rent]: "Aluguel",
  [EXPENSE_CATEGORY.Utilities]: "Contas (água, luz, internet)",
  [EXPENSE_CATEGORY.Payroll]: "Folha de pagamento",
  [EXPENSE_CATEGORY.Maintenance]: "Manutenção",
  [EXPENSE_CATEGORY.Services]: "Serviços",
  [EXPENSE_CATEGORY.Taxes]: "Impostos",
  [EXPENSE_CATEGORY.Supplies]: "Suprimentos",
  [EXPENSE_CATEGORY.Marketing]: "Marketing",
  [EXPENSE_CATEGORY.Other]: "Outros",
};

export const EXPENSE_STATUS = {
  Pending: 1,
  Paid: 2,
  Cancelled: 3,
} as const;

export const EXPENSE_STATUS_LABELS: Record<number, string> = {
  [EXPENSE_STATUS.Pending]: "Pendente",
  [EXPENSE_STATUS.Paid]: "Paga",
  [EXPENSE_STATUS.Cancelled]: "Cancelada",
};

export const MEMBERSHIP_PAYMENT_STATUS = {
  Pending: 1,
  Paid: 2,
  Cancelled: 3,
} as const;

export const MEMBERSHIP_PAYMENT_STATUS_LABELS: Record<number, string> = {
  [MEMBERSHIP_PAYMENT_STATUS.Pending]: "Pendente",
  [MEMBERSHIP_PAYMENT_STATUS.Paid]: "Paga",
  [MEMBERSHIP_PAYMENT_STATUS.Cancelled]: "Cancelada",
};

export const EXPENSE_RECURRENCE_TYPE = {
  None: 1,
  Weekly: 2,
  Monthly: 3,
  Yearly: 4,
} as const;

export const MEMBER_GENDER = {
  Male: 1,
  Female: 2,
  Other: 3,
  PreferNotToSay: 4,
} as const;

export const MEMBER_GENDER_LABELS: Record<number, string> = {
  [MEMBER_GENDER.Male]: "Masculino",
  [MEMBER_GENDER.Female]: "Feminino",
  [MEMBER_GENDER.Other]: "Outro",
  [MEMBER_GENDER.PreferNotToSay]: "Prefiro não informar",
};

export const MEMBER_ENROLLMENT_TYPE = {
  Internal: 1,
  Wellhub: 2,
  Totalpass: 3,
} as const;

export const MEMBER_ENROLLMENT_TYPE_LABELS: Record<number, string> = {
  [MEMBER_ENROLLMENT_TYPE.Internal]: "Interno",
  [MEMBER_ENROLLMENT_TYPE.Wellhub]: "Wellhub",
  [MEMBER_ENROLLMENT_TYPE.Totalpass]: "TotalPass",
};

export const BLOCK_REASON_TYPE = {
  Maintenance: 1,
  Tournament: 2,
  PrivateEvent: 3,
  Weather: 4,
  Other: 5,
} as const;

export const BLOCK_REASON_TYPE_LABELS: Record<number, string> = {
  [BLOCK_REASON_TYPE.Maintenance]: "Manutenção",
  [BLOCK_REASON_TYPE.Tournament]: "Torneio",
  [BLOCK_REASON_TYPE.PrivateEvent]: "Evento privado",
  [BLOCK_REASON_TYPE.Weather]: "Clima",
  [BLOCK_REASON_TYPE.Other]: "Outros",
};

export const EXPENSE_RECURRENCE_TYPE_LABELS: Record<number, string> = {
  [EXPENSE_RECURRENCE_TYPE.None]: "Sem recorrência",
  [EXPENSE_RECURRENCE_TYPE.Weekly]: "Semanal",
  [EXPENSE_RECURRENCE_TYPE.Monthly]: "Mensal",
  [EXPENSE_RECURRENCE_TYPE.Yearly]: "Anual",
};

export const TASK_STATUS = {
  ToDo: 1,
  InProgress: 2,
  Done: 3,
} as const;

export const TASK_STATUS_LABELS: Record<number, string> = {
  [TASK_STATUS.ToDo]: "A fazer",
  [TASK_STATUS.InProgress]: "Em andamento",
  [TASK_STATUS.Done]: "Concluído",
};

export const TASK_PRIORITY = {
  Low: 1,
  Medium: 2,
  High: 3,
} as const;

export const TASK_PRIORITY_LABELS: Record<number, string> = {
  [TASK_PRIORITY.Low]: "Baixa",
  [TASK_PRIORITY.Medium]: "Média",
  [TASK_PRIORITY.High]: "Alta",
};

export const INVITE_STATUS = {
  Pending: 0,
  Used: 1,
  Expired: 2,
  Revoked: 3,
} as const;

export const INVITE_STATUS_LABELS: Record<number, string> = {
  [INVITE_STATUS.Pending]: "Pendente",
  [INVITE_STATUS.Used]: "Usado",
  [INVITE_STATUS.Expired]: "Expirado",
  [INVITE_STATUS.Revoked]: "Revogado",
};

function labelFor(labels: Record<number, string>, value: number, fallback: (v: number) => string): string {
  return labels[value] ?? fallback(value);
}

export function paymentMethodLabel(value: number): string {
  return labelFor(PAYMENT_METHOD_LABELS, value, v => `Método ${v}`);
}

export function cashSessionStatusLabel(value: number): string {
  return labelFor(CASH_SESSION_STATUS_LABELS, value, v => `Status ${v}`);
}

export function cashTransactionTypeLabel(value: number): string {
  return labelFor(CASH_TRANSACTION_TYPE_LABELS, value, v => `Tipo ${v}`);
}

export function saleStatusLabel(value: number): string {
  return labelFor(SALE_STATUS_LABELS, value, v => `Status ${v}`);
}

export function saleTypeLabel(value: number): string {
  return labelFor(SALE_TYPE_LABELS, value, v => `Tipo ${v}`);
}

export function sportTypeLabel(value: number): string {
  return labelFor(SPORT_TYPE_LABELS, value, v => `Modalidade ${v}`);
}

export function bookingStatusLabel(value: number): string {
  return labelFor(BOOKING_STATUS_LABELS, value, v => `Status ${v}`);
}

export function planBillingPeriodLabel(value: number): string {
  return labelFor(PLAN_BILLING_PERIOD_LABELS, value, v => `Periodicidade ${v}`);
}

export function expenseCategoryLabel(value: number): string {
  return labelFor(EXPENSE_CATEGORY_LABELS, value, v => `Categoria ${v}`);
}

export function expenseStatusLabel(value: number): string {
  return labelFor(EXPENSE_STATUS_LABELS, value, v => `Status ${v}`);
}

export function membershipPaymentStatusLabel(value: number): string {
  return labelFor(MEMBERSHIP_PAYMENT_STATUS_LABELS, value, v => `Status ${v}`);
}

export function expenseRecurrenceTypeLabel(value: number): string {
  return labelFor(EXPENSE_RECURRENCE_TYPE_LABELS, value, v => `Recorrência ${v}`);
}

export function memberGenderLabel(value: number): string {
  return labelFor(MEMBER_GENDER_LABELS, value, v => `Gênero ${v}`);
}

export function memberEnrollmentTypeLabel(value: number): string {
  return labelFor(MEMBER_ENROLLMENT_TYPE_LABELS, value, v => `Origem ${v}`);
}

export function blockReasonTypeLabel(value: number): string {
  return labelFor(BLOCK_REASON_TYPE_LABELS, value, v => `Motivo ${v}`);
}

export function taskStatusLabel(value: number): string {
  return labelFor(TASK_STATUS_LABELS, value, v => `Status ${v}`);
}

export function taskPriorityLabel(value: number): string {
  return labelFor(TASK_PRIORITY_LABELS, value, v => `Prioridade ${v}`);
}

export function inviteStatusLabel(value: number): string {
  return labelFor(INVITE_STATUS_LABELS, value, v => `Status ${v}`);
}
